import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageCardLayout from 'src/components/PageCardLayout';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { AlertType, useAlert } from 'src/components/AlertsProvider';
import { COMPANIES as ROUTE_COMPANIES } from 'src/router';
import NewCompanyForm from './components/NewCompanyForm';
import { API_COMPANIES } from '../constants';

function NewCompany() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const goBack = () => navigate(ROUTE_COMPANIES);
  const [handleSubmit, loading] = useStatefulApi(
    (params) =>
      pepApiRequest({
        method: RequestMethod.Post,
        url: API_COMPANIES,
        params,
      }),
    () => {
      showAlert({
        type: AlertType.Success,
        title: 'New company has been added.',
        text: 'A company has been created successfully.',
      });
      goBack();
    }
  );

  return (
    <PageCardLayout loading={loading} title="Create new company">
      <NewCompanyForm onCancel={goBack} onSubmit={handleSubmit} />
    </PageCardLayout>
  );
}

export default NewCompany;
